
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Subscriptions',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();
        await this.GetAllCustomers();
        await this.GetAllProductsCounts();
        await this.GetAllPaymentsMethods();

        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },

        subtotal() {
            const subtotalValue = this.ruleForm.ProductsList.reduce((acc, item) => {
                return acc + (parseFloat(item.Price) || 0) * (parseFloat(item.Quantity) || 0);
            }, 0);
            this.ruleForm.SubTotal = subtotalValue; // Update the ruleForm with the subtotal
            return subtotalValue;
        },

        discountAmount() {
            const totalDiscount = this.ruleForm.ProductsList.reduce((acc, item) => {
                return acc + (parseFloat(item.Discount) || 0);
            }, 0);
            this.ruleForm.Discount = totalDiscount; // Update the ruleForm with the total discount
            return totalDiscount;
        },

        total() {
            const totalValue = this.ruleForm.SubTotal - this.ruleForm.Discount; // Total is calculated based on subtotal and discount
            this.ruleForm.Total = totalValue; // Update the ruleForm with the total
            return totalValue;
        }
    },

    watch: {
        'ProductsruleForm.Quantity': function () {
            this.handleQuantityChange(this.ProductsruleForm);
        },
        'ProductsruleForm.Discount': function () {
            this.handleDiscountChange(this.ProductsruleForm);
        },

        'ruleForm.ProductsList': {
            handler() {
                // Recalculate subtotal, discount, and total
                this.subtotal; // This will update ruleForm.SubTotal
                this.discountAmount; // This will update ruleForm.Discount (access as property)
                this.total; // This will update ruleForm.Total
            },
            deep: true,
        },
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: ' فواتير المبيعات    ',
            ScreenTitleSingle: ' فاتورة مبيعات  ',
            ScreenTitleSingleAl: 'الفاتورة  ',

            Info: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem: '',

            

            ruleForm: {
                Id: '',
                Type: '',
                CustomersId: '',
                ReferenceNumber: '',
                Number: '',
                Date: '',
                Code: '',
                Note: '',
                Role: '',

                IsInstallments: '',
                IsPrintNote: '',
                IsPrintRole: '',

                SubTotal: '',
                Total: '',
                Discount: '',

                Descriptions: '',
                
                
                
                Value: '',
                PaymentsMethodsId: '',
                
                ProductsList: [ 
                    {
                        ProductsId: '',
                        Quantity: '',
                        Price: '',
                        Discount: '',
                        Total: '',
                        Descriptions: '',
                        ExpiryDate: '',
                        SerialNumber: '',
                        AvailableQuantity: 0,
                        ProductsPrice: 0,

                    },
                ],
            },
            rules: {
                CustomersId: this.$helper.Required(),
                Date: this.$helper.Required(),
                Code: this.$helper.Required(),
                SubTotal: this.$helper.Required(),
                Discount: this.$helper.Required(),
                Total: this.$helper.Required(),
            },

            AvailableQuantity:0,
            ProductsPrice:0,




            ProductsList:[],

            ItemruleForm: {
                Id:'',
                ProductsId: '',
                Quantity: '',
                Price: '',
                Discount: '',
                Total: '',
                Descriptions: '',
                ExpiryDate: '',
                SerialNumber: '',
            },

            Itemrulerules: {
                ProductsId: this.$helper.Required(),
                Quantity: this.$helper.Required(),
                Price: this.$helper.Required(),
                SerialNumber: this.$helper.Required(),
            },



            //Installments
            Installments: [],

            InstallmentsruleForm: {
                Id: '',
                Value: '',
                Quantity: '',
                PaymentsMethodsId: '',
                InvoicesId: '',
                Type: '',
            },

            Installmentsrules: {
                Value: this.$helper.Required(),
                PaymentsMethodsId: this.$helper.Required(),
            },


        };
    },


   

    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetInvoiceOut(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },
       
        OpenAddDilaog(ruleForm) {
            this.state = 1;
            this.ClearFormStatic(ruleForm);

            this.$blockUI.Start();
            this.$http.GetInvoiceNumber(2)
                .then(response => {
                    this.$blockUI.Stop();
                    this.ruleForm.Number = response.data.number;
                    this.ruleForm.Code = response.data.code;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        ChangeProduct(id) {
            const product = this.ProductsCounts.find(x => x.id === id);
            if (product) {
                this.AvailableQuantity = product.quantity;
                this.ProductsPrice = product.price;
                this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].AvailableQuantity = product.quantity;
                this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].ProductsPrice = product.price;
            } 
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    if (!this.ruleForm.ProductsList || this.ruleForm.ProductsList.length === 0) {
                        this.$helper.ShowMessage('warning', 'يرجى إضافة منتجات إلى القائمة');
                        return false; 
                    }

                    this.ruleForm.Id = Number(0);

                    this.ruleForm.Type = Number(2);

                    if (!this.ruleForm.Date)
                        this.ruleForm.Date = null;

                    if (!this.ruleForm.IsInstallments)
                        this.ruleForm.IsInstallments = false;

                    if (!this.ruleForm.IsPrintNote)
                        this.ruleForm.IsPrintNote = false;

                    if (!this.ruleForm.IsPrintRole)
                        this.ruleForm.IsPrintRole = false;


                    if (this.ruleForm.SubTotal) {
                        this.ruleForm.SubTotal = Number(this.ruleForm.SubTotal);
                    } else {
                        this.ruleForm.SubTotal = Number(0);
                    }

                    if (this.ruleForm.Discount) {
                        this.ruleForm.Discount = Number(this.ruleForm.Discount);
                    } else {
                        this.ruleForm.Discount = Number(0);
                    }

                    if (this.ruleForm.Total) {
                        this.ruleForm.Total = Number(this.ruleForm.Total);
                    } else {
                        this.ruleForm.Total = Number(0);
                    }

                    if (this.ruleForm.Value) {
                        this.ruleForm.Value = Number(this.ruleForm.Value);
                    } else {
                        this.ruleForm.Value = Number(0);
                    }

                    if (this.ruleForm.PaymentsMethodsId) {
                        this.ruleForm.PaymentsMethodsId = Number(this.ruleForm.PaymentsMethodsId);
                    } else {
                        this.ruleForm.PaymentsMethodsId = Number(0);
                    }



                    this.ruleForm.ProductsList = this.ruleForm.ProductsList.map(product => ({
                        ProductsId: product.ProductsId,
                        Quantity: parseInt(product.Quantity, 10), // Convert Quantity to int
                        Price: parseFloat(product.Price), // Ensure Price is a float
                        Discount: parseFloat(product.Discount) || 0, // Convert Discount to float or default to 0
                        Total: parseFloat(product.Total), // Ensure Total is a float
                        Descriptions: product.Descriptions,
                    }));



                    this.$blockUI.Start();
                    this.$http.AddInvoiceOut(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.state = 0;
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطأ غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        submitSaveForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    if (!this.ruleForm.ProductsList || this.ruleForm.ProductsList.length === 0) {
                        this.$helper.ShowMessage('warning', 'يرجى إضافة منتجات إلى القائمة');
                        return false;
                    }

                    this.ruleForm.Id = Number(0);

                    this.ruleForm.Type = Number(2);

                    if (!this.ruleForm.Date)
                        this.ruleForm.Date = null;

                    if (!this.ruleForm.IsInstallments)
                        this.ruleForm.IsInstallments = false;

                    if (!this.ruleForm.IsPrintNote)
                        this.ruleForm.IsPrintNote = false;

                    if (!this.ruleForm.IsPrintRole)
                        this.ruleForm.IsPrintRole = false;


                    if (this.ruleForm.SubTotal) {
                        this.ruleForm.SubTotal = Number(this.ruleForm.SubTotal);
                    } else {
                        this.ruleForm.SubTotal = Number(0);
                    }

                    if (this.ruleForm.Discount) {
                        this.ruleForm.Discount = Number(this.ruleForm.Discount);
                    } else {
                        this.ruleForm.Discount = Number(0);
                    }

                    if (this.ruleForm.Total) {
                        this.ruleForm.Total = Number(this.ruleForm.Total);
                    } else {
                        this.ruleForm.Total = Number(0);
                    }

                    if (this.ruleForm.Value) {
                        this.ruleForm.Value = Number(this.ruleForm.Value);
                    } else {
                        this.ruleForm.Value = Number(0);
                    }

                    if (this.ruleForm.PaymentsMethodsId) {
                        this.ruleForm.PaymentsMethodsId = Number(this.ruleForm.PaymentsMethodsId);
                    } else {
                        this.ruleForm.PaymentsMethodsId = Number(0);
                    }



                    this.ruleForm.ProductsList = this.ruleForm.ProductsList.map(product => ({
                        ProductsId: product.ProductsId,
                        Quantity: parseInt(product.Quantity, 10), // Convert Quantity to int
                        Price: parseFloat(product.Price), // Ensure Price is a float
                        Discount: parseFloat(product.Discount) || 0, // Convert Discount to float or default to 0
                        Total: parseFloat(product.Total), // Ensure Total is a float
                        Descriptions: product.Descriptions,
                    }));



                    this.$blockUI.Start();
                    this.$http.SaveInvoiceOut(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.GetAllProductsCounts();

                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.state = 0;
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطأ غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpentEditDialog(item) {
            this.ClearFormStatic(this.ruleForm);
            this.state = 2;
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Type = item.type;
            this.ruleForm.CustomersId = item.customersId;
            this.ruleForm.ReferenceNumber = item.referenceNumber;
            this.ruleForm.Number = item.number;
            this.ruleForm.Date = item.date;
            this.ruleForm.Code = item.code;
            this.ruleForm.Note = item.note;
            this.ruleForm.Role = item.role;
            this.ruleForm.IsInstallments = item.isInstallments;
            this.ruleForm.IsPrintNote = item.isPrintNote;
            this.ruleForm.IsPrintRole = item.isPrintRole;
            this.ruleForm.CompletedInstallment = item.completedInstallment;
            this.ruleForm.SubTotal = item.subTotal;
            this.ruleForm.Total = item.total;
            this.ruleForm.Discount = item.discount;
            this.ruleForm.Value = item.value;
            this.GetInvoiceProducts();
        },

        GetInvoiceProducts() {
            this.$blockUI.Start();
            this.$http.GetInvoiceProducts(this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.ProductsList = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        AddItemToInvoice(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    if (!this.ItemruleForm.ProductsId) {
                        this.$helper.ShowMessage('warning', 'يرجى إضافة   الصنف');
                        return false;
                    }


                    if (!this.ItemruleForm.Quantity) {
                        this.$helper.ShowMessage('warning', 'يرجى إضافة   الكمية');
                        return false;
                    }

                    this.ItemruleForm.Id = this.SelectedItem.id;
                    this.ItemruleForm.Quantity = parseInt(this.ItemruleForm.Quantity, 10); // Convert Quantity to int
                    this.ItemruleForm.Price = parseFloat(this.ItemruleForm.Price); // Ensure Price is a float
                    this.ItemruleForm.Discount = parseFloat(this.ItemruleForm.Discount) || 0; // Convert Discount to float or default to 0
                    this.ItemruleForm.Total = parseFloat(this.ItemruleForm.Total); // Ensure Total is a float
                    this.ItemruleForm.ExpiryDate = new Date(this.ItemruleForm.ExpiryDate); // Convert to Date object






                    this.$blockUI.Start();
                    this.$http.AddItemToInvoice(this.ItemruleForm)
                        .then(response => {
                            this.SelectedItem.subTotal += this.ItemruleForm.Total;
                            this.SelectedItem.total += this.ItemruleForm.Total;
                            this.SelectedItem.discount += this.ItemruleForm.Discount;
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.GetInvoiceProducts();
                            

                            

                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.ClearForm(this.ItemruleForm);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطأ غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        DeleteItem(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteInvoiceItem(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                            this.GetInvoiceProducts();

                            const item = this.ProductsList.find(product => product.id === Id);
                            this.SelectedItem.subTotal -= item.total;
                            this.SelectedItem.total -= item.total;
                            this.SelectedItem.discount -= item.discount;

                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(this.ruleForm.Id);

                    this.ruleForm.Type = Number(1);

                    if (!this.ruleForm.Date)
                        this.ruleForm.Date = null;

                    if (!this.ruleForm.IsInstallments)
                        this.ruleForm.IsInstallments = false;

                    if (!this.ruleForm.IsPrintNote)
                        this.ruleForm.IsPrintNote = false;

                    if (!this.ruleForm.IsPrintRole)
                        this.ruleForm.IsPrintRole = false;



                    this.$blockUI.Start();
                    this.$http.EditInvoiceIn(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطأ غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة الحساب  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusProducts(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteInvoiceIn(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Cancel(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية إلغاء الفاتورة  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.CancelInvoiceIn(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإلغاء', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإلغاء', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        submitInvoice() {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية إعتماد الفاتورة   ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ConfirmInvoiceIn(this.SelectedItem.id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                            this.state = 0;
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإعتماد', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإعتماد', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },




        GetInvoiceInstallments() {
            this.$blockUI.Start();
            this.$http.GetInvoiceInstallments(this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.Installments = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        OpentInstallmentsDialog(item) {
            this.SelectedItem = item;
            this.ClearForm(this.InstallmentsruleForm);
            this.GetInvoiceInstallments();
        },

        submitInstallmentForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    this.InstallmentsruleForm.Id = Number(0);
                    this.InstallmentsruleForm.Value = Number(this.InstallmentsruleForm.Value);
                    this.InstallmentsruleForm.InvoicesId = this.SelectedItem.id;
                    this.InstallmentsruleForm.Type = Number(1);


                    this.$blockUI.Start();
                    this.$http.AddInstallment(this.InstallmentsruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.GetInvoiceInstallments();
                            this.ClearForm(this.InstallmentsruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.state = 0;
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطأ غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        DeleteInstallment(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteInstallment(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                            this.GetInvoiceInstallments();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطأ غير متوقع');
                            }
                        });
                    return;
                }
            });
        },










        //Support Info
        Back() {
            this.state = 0;
            this.ClearForm(this.ruleForm);
            this.SelectedItem = '';
            this.GetInfo(this.pageNo);
        },

        ClearFormStatic(ruleForm) {
            for (const key in ruleForm) {
                if (Array.isArray(ruleForm[key])) {
                    ruleForm[key] = []; // Reset to an empty array if it's an array
                } else {
                    ruleForm[key] = ''; // Reset to an empty string for other types
                }
            }
            ruleForm.ProductsList = [
                {
                    ProductsId: '',
                    Quantity: '',
                    Price: '',
                    Discount: '',
                    Total: '',
                    Descriptions: '',
                    ExpiryDate: '',
                    SerialNumber: '',
                },
            ];
        },

        calculateTotal(item) {
            const price = parseFloat(item.Price) || 0; // Ensure price is a float
            const quantity = parseFloat(item.Quantity) || 0; // Ensure quantity is a float
            const discount = parseFloat(item.Discount) || 0; // Ensure discount is a float

            // Calculate total with discount if applicable
            const total = quantity * price;
            const discountedTotal = total - (total * (discount / 100));

            // Update the item's total
            item.Total = discount > 0 ? discountedTotal : total;
        },

        addItem() {

            if (this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].ProductsId <= 0) 
                this.$helper.ShowMessage('error', 'خطأ بعملية إضافة الصنف', 'الرجاء التأكد من إختيار الصنف');

            if (this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Quantity <= 0)
                this.$helper.ShowMessage('error', 'خطأ بعملية إضافة الصنف', 'الرجاء التأكد من إدخال  الكمية');


            if (this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].ProductsId > 0 && 
                this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Quantity  > 0
            ) {


                //if (this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Price) {
                //    this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Price = Number(this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Price);
                //} else {
                //    this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Price = Number(0);
                //}

                //if (this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Quantity) {
                //    this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Quantity = Number(this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Quantity);
                //} else {
                //    this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Quantity = Number(0);
                //}

                //if (this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Discount) {
                //    this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Discount = Number(this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Discount);
                //} else {
                //    this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].Discount = Number(0);
                //}

                //if (!this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].ExpiryDate)
                //    this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].ExpiryDate = null;


                this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].AvailableQuantity = this.AvailableQuantity;
                this.ruleForm.ProductsList[this.ruleForm.ProductsList.length - 1].ProductsPrice = this.ProductsPrice;

                // Push a copy of the ProductsruleForm to the ProductsList
                this.ruleForm.ProductsList.push({ ...this.ProductsruleForm });

                // Reset the form after adding
                this.resetForm();
            }

            
        },

        resetForm() {
            this.ProductsruleForm = {
                ProductsId: '',
                Quantity: '',
                Price: '',
                Discount: '',
                Total: '',
                Descriptions: '',
                ExpiryDate: '',
                SerialNumber: '',
            };
        },

        deleteItem(index) {
            // Remove the item at the specified index
            this.ruleForm.ProductsList.splice(index, 1);
        },

        handleQuantityChange(item) {
            
            if (item.Quantity > this.AvailableQuantity) {
                item.Quantity = 0;
            } 
            this.calculateTotal(item);
        },

        handleDiscountChange(item) {
            this.calculateTotal(item);
        },

    }
}
